export default __webpack_public_path__ + "static/media/instagram_icon.0963b7a5.png";